import { AssetClass } from "@/types/portfolio";
import AssetAllocationControls from "./AssetAllocationControls";

interface AssetAllocationListProps {
  assetClasses: AssetClass[];
  portfolioSize: number;
  onSliderChange: (index: number, newValue: number) => void;
  onInputChange: (index: number, value: string) => void;
  onInputBlur: (index: number) => void;
}

const AssetAllocationList = ({
  assetClasses,
  portfolioSize,
  onSliderChange,
  onInputChange,
  onInputBlur
}: AssetAllocationListProps) => {
  return (
    <div className="space-y-4">
      {(assetClasses || []).map((asset, index) => (
        <AssetAllocationControls
          key={asset.name}
          assetClass={asset}
          portfolioSize={portfolioSize}
          onChange={(value) => onSliderChange(index, value)}
          onInputChange={(value) => onInputChange(index, value)}
          onInputBlur={() => onInputBlur(index)}
        />
      ))}
    </div>
  );
};

export default AssetAllocationList;